module.exports = __webpack_public_path__ + "media/welcome.518da848.mp3";